module.exports = __webpack_public_path__ + "img/gender_active.8f197d7a.svg";